var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 11.3C13.327 11.3 14.4016 10.2255 14.4016 8.9C14.4016 7.57452 13.327 6.5 12.0016 6.5C10.6761 6.5 9.60156 7.57452 9.60156 8.9C9.60156 10.2255 10.6761 11.3 12.0016 11.3Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0016 3.5C13.4337 3.5 14.8072 4.06893 15.8199 5.08162C16.8326 6.09432 17.4016 7.46783 17.4016 8.9C17.4016 11.5008 13.296 17.3216 12.2448 18.7696C12.2167 18.8078 12.1801 18.8389 12.1379 18.8603C12.0956 18.8817 12.0489 18.8928 12.0016 18.8928C11.9542 18.8928 11.9075 18.8817 11.8652 18.8603C11.823 18.8389 11.7864 18.8078 11.7584 18.7696C10.7072 17.3216 6.60156 11.5008 6.60156 8.9C6.60156 7.46783 7.17049 6.09432 8.18319 5.08162C9.19588 4.06893 10.5694 3.5 12.0016 3.5Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7848 17.127C18.9704 17.5598 20.4016 18.2822 20.4016 19.0998C20.4016 20.4254 16.6416 21.4998 12.0016 21.4998C7.36156 21.4998 3.60156 20.4254 3.60156 19.0998C3.60156 18.2838 5.02636 17.563 7.20156 17.1294",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8fd35cc1d058dc09a99d2c32df1cda9d.svg";
export { ForwardRef as ReactComponent };